import React, { useEffect, useState } from 'react';

import { useTranslation } from "contexts";

import { Card } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";

const DirectPaymentHomepage = () => {
    const { state } = useLocation();

    const [ messageToShow ] = useState(state?.message);
    
    const translate = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        if( !messageToShow ) return ;
        navigate("/p", { replace: true });
    }, [messageToShow, navigate])

    return(
        <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ height: 'calc(100vh - 20px)' }}
        >
            <Card
                className="p-4 d-flex flex-column"
                style={{
                    width: 'clamp(350px, 60vw, 900px)',
                    minHeight: 'clamp(200px, 40vh, 400px)',
                }}
                styles={{
                    body: {
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '0',
                        height: '100%',
                    }
                }}
            >
                <div className="text-center" style={{ width: '100%', overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                    <h4 className="mb-3" style={{ fontSize: 'clamp(1.2rem, 3.8vw, 1.8rem)' }}>
                        { translate("PaymentModuleTitle") }
                    </h4>

                    <p className="m-0" style={{ fontSize: 'clamp(0.9rem, 2.5vw, 1rem)' }}>
                        { translate("PaymentModuleExplanationOne") }
                    </p>
                    <p className="m-0" style={{ fontSize: 'clamp(0.9rem, 2.5vw, 1rem)' }}>
                        { translate("PaymentModuleExplanationTwo") }
                    </p>
                </div>

                {
                    messageToShow && messageToShow.length > 0 && 
                    (
                        <div
                            className="my-3 d-flex flex-column align-items-center justify-content-center"
                            style={{ flexGrow: 1 }}
                        >
                            {
                                messageToShow.map((key, i) => (
                                    <div key={i} className="fw-semibold text-center" style={{ fontSize: 'clamp(0.9rem, 2vw, 1.2rem)', overflowWrap: 'break-word' }}>
                                        { translate(key) }
                                    </div>
                                ))
                            }
                        </div>
                    )
                }

                <div style={{ marginTop: 'auto', width: '100%' }}>
                    <p className="text-muted text-center mb-1" style={{ fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)' }}>
                        🔒 {translate("PaymentModuleSecureMessage")}
                    </p>
                    <p
                        className="fst-italic mb-0"
                        style={{ textAlign: 'right', fontSize: 'clamp(0.8rem, 1.5vw, 0.95rem)', marginTop: '0.25rem', overflowWrap: 'break-word' }}
                    >
                        {translate("PaymentModuleHelpMessage")} +33 4 12 29 04 27
                    </p>
                </div>
            </Card>

            <div
                style={{
                    width: 'clamp(350px, 60vw, 900px)',
                    textAlign: 'right',
                    marginTop: '6px',
                    fontSize: '0.85rem',
                    color: '#6c757d'
                }}
            >
                © {new Date().getFullYear()} Recouvéo
            </div>
        </div>
    );
}

export default DirectPaymentHomepage;